
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const EditUser = () => {

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem('jwt_token');
  const { id } = useParams();
  const [roles, setRoles] = useState([]);
  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}api/getUserDetails/${id}`, {
          method: 'GET', // No body for GET requests
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });
  
        // Check if the response is okay
        if (response.ok) {
          const data = await response.json();
          if (data && data.data) {
            setFormData(data.data); // Prepopulate the form with data
          } else {
            console.error('Error: No data found');
          }
        } else {
          console.error('Error: Failed to fetch user details');
        }
      } catch (error) {
        console.error('Error:', error);
      }
    };
  
    fetchUserDetails();
  }, [API_BASE_URL, token, id]);
  const [formData, setFormData] = useState({
    emp_code: '',
    fname: '',
    lname: '',
    mail_id: '',
    phone: '',
    address: '',
    role: '',
    gender: 'M',
    image: '',
  });



  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState(null);


  useEffect(() => {
    const fetchRoles = async () => {
      const res = await fetch(`${API_BASE_URL}api/getRoleList`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
      });
      const data = await res.json();
      console.log(data);
      setRoles(Array.isArray(data.data) ? data.data : []);
    };
    fetchRoles();
  }, [API_BASE_URL, token]);



  // Handle file preview
  useEffect(() => {
    if (!selectedFile) {
      setPreview(null);
      return;
    }
    const objectUrl = URL.createObjectURL(selectedFile);
    setPreview(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedFile]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedFile(file);
    }
  };
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
      formDataToSend.append(key, formData[key]);
    });

    if (selectedFile) {
      formDataToSend.append('profile_pic', selectedFile);
    }

    try {
      const response = await fetch(`${API_BASE_URL}api/editUser/${id}`, {
        method: 'POST', // Change to PUT or PATCH for editing
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formDataToSend,
      });

      if (response.ok) {
        setError('updated');
        
        // Clear the error after 3 seconds
        setTimeout(() => {
            setError('');
        }, 3000);
    
        // Redirect to doctors list (uncomment if needed)
        // window.location.href = '/edit_user/' + id;
    } else {
        const data = await response.json();
        setError(data.message);
        setSuccess('');
    
        // Clear the error after 3 seconds
        setTimeout(() => {
            setError('');
        }, 3000);
    }
    
    } catch (error) {
      setError(error.message);
      setSuccess('');
    }
    setLoading(false);
  };



  return (
    <div className="wrapper">
      <Sidebar />
      <main className="main-content content-page">
        <div className="position-relative">
          <Navbar />
        </div>
        <div className="content-inner container-fluid pb-0" id="page_layout">
          <div className="row">
            <div className="col-sm-12">
              <form onSubmit={handleFormSubmit}>
                {error && <div className="alert alert-danger">{error}</div>}
                {success && <div className="alert alert-success">{success}</div>}
                {loading && <div>Loading...</div>}

                <div className="row">
                  <div className="form-group col-md-6">
                    <label htmlFor="fname">First Name:</label>
                    <input
                      type="text"
                      className="form-control form-control-sm my-2"
                      id="fname"
                      name="fname"
                      value={formData.fname}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="form-group col-md-6">
                    <label htmlFor="lname">Last Name:</label>
                    <input
                      type="text"
                      className="form-control form-control-sm my-2"
                      id="lname"
                      name="lname"
                      value={formData.lname}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="form-group col-md-6">
                    <label htmlFor="emp_code">BMID:</label>
                    <input
                      type="text"
                      className="form-control form-control-sm my-2"
                      id="emp_code"
                      name="emp_code"
                      value={formData.emp_code}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="form-group col-md-6">
                    <label htmlFor="gender">Gender</label>
                    <select
                      className="form-control form-control-sm my-2"
                      id="gender"
                      name="gender"
                      value={formData.gender}
                      onChange={handleInputChange}
                    >
                      <option value="M">Male</option>
                      <option value="F">Female</option>
                    </select>
                  </div>
                  <div className="form-group col-md-6">
                    <label htmlFor="mail_id">Email Id:</label>
                    <input
                      type="mail_id"
                      className="form-control form-control-sm my-2"
                      id="mail_id"
                      name="mail_id"
                      value={formData.mail_id}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="form-group col-md-6">
                    <label htmlFor="mobile">Mobile Number:</label>
                    <input
                      type="text"
                      className="form-control form-control-sm my-2"
                      id="mobile"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleInputChange}

                    />
                  </div>
                  <div className="form-group col-md-6">
                    <label htmlFor="mobile">Role:</label>
                    <select
                      className="form-control form-control-sm my-2"
                      id="role"
                      name="role"
                      value={formData.role}
                      onChange={handleInputChange}>
                      {roles.filter(role => role.role.toLowerCase() !== 'doctor').map((role) => (
                        <option key={role.role_id} value={role.role}>
                          {role.role}
                        </option>
                      ))}
                    </select>

                  </div>
                </div>
                {/* <div className="form-group">
                  <input type="file" onChange={handleFileChange} className="form-control" />
                  {preview && <img src={preview} alt="Preview" style={{ width: '200px' }} />}
                </div> */}

                <button type="submit" className="btn btn-primary">Update</button>
              </form>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default EditUser;
